/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * RIA Multi-Agent System
 * Remediation Intelligence Agent for audits and compliance automation
 * OpenAPI spec version: 1.0.0
 */
import type {
  AgentStatus,
  AgentsHealthCheckResponse,
  AgentsListResponse,
  AuditGetAuditLogsParams,
  AuditLogResponse,
  BatchApprovalRequest,
  BatchMarkReadRequest,
  BatchMarkReadResponse,
  BatchRejectionRequest,
  BatchTaskOperationResponse,
  BodyHrUploadSapFile,
  ExecutableRuleCreate,
  ExecutableRuleUpdate,
  ExecutableRulesListResponse,
  FileUploadResponse,
  HTTPValidationError,
  HrListExportsParams,
  NotificationsGetNotificationsParams,
  NotificationsListResponse,
  PeriodicRuleCreate,
  PeriodicRuleUpdate,
  PeriodicRulesListResponse,
  PeriodicTask,
  PeriodicTaskBatchOperationResponse,
  PeriodicTaskBatchStartRequest,
  PeriodicTasksListResponse,
  PolicyDeleteExecutableRule200,
  PolicyDeletePeriodicRule200,
  PolicyExecutableRule,
  PolicyPeriodicRule,
  RemediationTask,
  RemediationTaskBatchOperationResponse,
  RemediationTaskDataPoint,
  RootResponse,
  RulesSeedResponse,
  RulesSyncResponse,
  SFExportsListResponse,
  StatisticsCompliancyResponse,
  StatisticsGetRemediationTasksStatisticsParams,
  StatisticsTaskTotals,
  TasksGetAllTasksParams,
  TasksGetPeriodicTasksParams,
  TasksListResponse,
  TriggerRuleResponse,
} from './ria-multi-agent-system.schemas'

import { customFetch } from '../utils/custom-fetch'

/**
 * Global health check - returns health status for all agents
 * @summary Health Check
 */
export type healthHealthCheckResponse200 = {
  data: AgentsHealthCheckResponse
  status: 200
}

export type healthHealthCheckResponseSuccess = healthHealthCheckResponse200 & {
  headers: Headers
}
export type healthHealthCheckResponse = healthHealthCheckResponseSuccess

export const getHealthHealthCheckUrl = () => {
  return `/health`
}

export const healthHealthCheck = async (
  options?: RequestInit
): Promise<healthHealthCheckResponse> => {
  return customFetch<healthHealthCheckResponse>(getHealthHealthCheckUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Get status of all agents with detailed metrics
 * @summary Get System Status
 */
export type statusGetSystemStatusResponse200 = {
  data: AgentsListResponse
  status: 200
}

export type statusGetSystemStatusResponseSuccess =
  statusGetSystemStatusResponse200 & {
    headers: Headers
  }
export type statusGetSystemStatusResponse = statusGetSystemStatusResponseSuccess

export const getStatusGetSystemStatusUrl = () => {
  return `/api/agents/status`
}

export const statusGetSystemStatus = async (
  options?: RequestInit
): Promise<statusGetSystemStatusResponse> => {
  return customFetch<statusGetSystemStatusResponse>(
    getStatusGetSystemStatusUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Get detailed status of a specific agent
 * @summary Get Agent Status
 */
export type statusGetAgentStatusResponse200 = {
  data: AgentStatus
  status: 200
}

export type statusGetAgentStatusResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type statusGetAgentStatusResponseSuccess =
  statusGetAgentStatusResponse200 & {
    headers: Headers
  }
export type statusGetAgentStatusResponseError =
  statusGetAgentStatusResponse422 & {
    headers: Headers
  }

export type statusGetAgentStatusResponse =
  | statusGetAgentStatusResponseSuccess
  | statusGetAgentStatusResponseError

export const getStatusGetAgentStatusUrl = (agentName: string) => {
  return `/api/agents/${agentName}/status`
}

export const statusGetAgentStatus = async (
  agentName: string,
  options?: RequestInit
): Promise<statusGetAgentStatusResponse> => {
  return customFetch<statusGetAgentStatusResponse>(
    getStatusGetAgentStatusUrl(agentName),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Upload and import SAP SuccessFactors Excel file

This endpoint will:
1. Parse the file and import employee data
2. Trigger policy evaluation via the RIA agent
3. Return import status and policy evaluation results
 * @summary Upload Sap File
 */
export type hrUploadSapFileResponse200 = {
  data: FileUploadResponse
  status: 200
}

export type hrUploadSapFileResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type hrUploadSapFileResponseSuccess = hrUploadSapFileResponse200 & {
  headers: Headers
}
export type hrUploadSapFileResponseError = hrUploadSapFileResponse422 & {
  headers: Headers
}

export type hrUploadSapFileResponse =
  | hrUploadSapFileResponseSuccess
  | hrUploadSapFileResponseError

export const getHrUploadSapFileUrl = () => {
  return `/api/hr/upload`
}

export const hrUploadSapFile = async (
  bodyHrUploadSapFile: BodyHrUploadSapFile,
  options?: RequestInit
): Promise<hrUploadSapFileResponse> => {
  const formData = new FormData()
  formData.append(`file`, bodyHrUploadSapFile.file)

  return customFetch<hrUploadSapFileResponse>(getHrUploadSapFileUrl(), {
    ...options,
    method: 'POST',
    body: formData,
  })
}

/**
 * List recent SuccessFactors exports
 * @summary List Exports
 */
export type hrListExportsResponse200 = {
  data: SFExportsListResponse
  status: 200
}

export type hrListExportsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type hrListExportsResponseSuccess = hrListExportsResponse200 & {
  headers: Headers
}
export type hrListExportsResponseError = hrListExportsResponse422 & {
  headers: Headers
}

export type hrListExportsResponse =
  | hrListExportsResponseSuccess
  | hrListExportsResponseError

export const getHrListExportsUrl = (params?: HrListExportsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/hr/exports?${stringifiedParams}`
    : `/api/hr/exports`
}

export const hrListExports = async (
  params?: HrListExportsParams,
  options?: RequestInit
): Promise<hrListExportsResponse> => {
  return customFetch<hrListExportsResponse>(getHrListExportsUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * List all executable rules from database
 * @summary List Executable Rules
 */
export type policyListExecutableRulesResponse200 = {
  data: ExecutableRulesListResponse
  status: 200
}

export type policyListExecutableRulesResponseSuccess =
  policyListExecutableRulesResponse200 & {
    headers: Headers
  }
export type policyListExecutableRulesResponse =
  policyListExecutableRulesResponseSuccess

export const getPolicyListExecutableRulesUrl = () => {
  return `/api/policy/rules/executable`
}

export const policyListExecutableRules = async (
  options?: RequestInit
): Promise<policyListExecutableRulesResponse> => {
  return customFetch<policyListExecutableRulesResponse>(
    getPolicyListExecutableRulesUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Create a new executable rule
 * @summary Create Executable Rule
 */
export type policyCreateExecutableRuleResponse201 = {
  data: PolicyExecutableRule
  status: 201
}

export type policyCreateExecutableRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyCreateExecutableRuleResponseSuccess =
  policyCreateExecutableRuleResponse201 & {
    headers: Headers
  }
export type policyCreateExecutableRuleResponseError =
  policyCreateExecutableRuleResponse422 & {
    headers: Headers
  }

export type policyCreateExecutableRuleResponse =
  | policyCreateExecutableRuleResponseSuccess
  | policyCreateExecutableRuleResponseError

export const getPolicyCreateExecutableRuleUrl = () => {
  return `/api/policy/rules/executable`
}

export const policyCreateExecutableRule = async (
  executableRuleCreate: ExecutableRuleCreate,
  options?: RequestInit
): Promise<policyCreateExecutableRuleResponse> => {
  return customFetch<policyCreateExecutableRuleResponse>(
    getPolicyCreateExecutableRuleUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(executableRuleCreate),
    }
  )
}

/**
 * Get a single executable rule by ID
 * @summary Get Executable Rule
 */
export type policyGetExecutableRuleResponse200 = {
  data: PolicyExecutableRule
  status: 200
}

export type policyGetExecutableRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyGetExecutableRuleResponseSuccess =
  policyGetExecutableRuleResponse200 & {
    headers: Headers
  }
export type policyGetExecutableRuleResponseError =
  policyGetExecutableRuleResponse422 & {
    headers: Headers
  }

export type policyGetExecutableRuleResponse =
  | policyGetExecutableRuleResponseSuccess
  | policyGetExecutableRuleResponseError

export const getPolicyGetExecutableRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/executable/${ruleId}`
}

export const policyGetExecutableRule = async (
  ruleId: string,
  options?: RequestInit
): Promise<policyGetExecutableRuleResponse> => {
  return customFetch<policyGetExecutableRuleResponse>(
    getPolicyGetExecutableRuleUrl(ruleId),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Update an existing executable rule
 * @summary Update Executable Rule
 */
export type policyUpdateExecutableRuleResponse200 = {
  data: PolicyExecutableRule
  status: 200
}

export type policyUpdateExecutableRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyUpdateExecutableRuleResponseSuccess =
  policyUpdateExecutableRuleResponse200 & {
    headers: Headers
  }
export type policyUpdateExecutableRuleResponseError =
  policyUpdateExecutableRuleResponse422 & {
    headers: Headers
  }

export type policyUpdateExecutableRuleResponse =
  | policyUpdateExecutableRuleResponseSuccess
  | policyUpdateExecutableRuleResponseError

export const getPolicyUpdateExecutableRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/executable/${ruleId}`
}

export const policyUpdateExecutableRule = async (
  ruleId: string,
  executableRuleUpdate: ExecutableRuleUpdate,
  options?: RequestInit
): Promise<policyUpdateExecutableRuleResponse> => {
  return customFetch<policyUpdateExecutableRuleResponse>(
    getPolicyUpdateExecutableRuleUrl(ruleId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(executableRuleUpdate),
    }
  )
}

/**
 * Delete an executable rule
 * @summary Delete Executable Rule
 */
export type policyDeleteExecutableRuleResponse200 = {
  data: PolicyDeleteExecutableRule200
  status: 200
}

export type policyDeleteExecutableRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyDeleteExecutableRuleResponseSuccess =
  policyDeleteExecutableRuleResponse200 & {
    headers: Headers
  }
export type policyDeleteExecutableRuleResponseError =
  policyDeleteExecutableRuleResponse422 & {
    headers: Headers
  }

export type policyDeleteExecutableRuleResponse =
  | policyDeleteExecutableRuleResponseSuccess
  | policyDeleteExecutableRuleResponseError

export const getPolicyDeleteExecutableRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/executable/${ruleId}`
}

export const policyDeleteExecutableRule = async (
  ruleId: string,
  options?: RequestInit
): Promise<policyDeleteExecutableRuleResponse> => {
  return customFetch<policyDeleteExecutableRuleResponse>(
    getPolicyDeleteExecutableRuleUrl(ruleId),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

/**
 * List all periodic rules from database
 * @summary List Periodic Rules
 */
export type policyListPeriodicRulesResponse200 = {
  data: PeriodicRulesListResponse
  status: 200
}

export type policyListPeriodicRulesResponseSuccess =
  policyListPeriodicRulesResponse200 & {
    headers: Headers
  }
export type policyListPeriodicRulesResponse =
  policyListPeriodicRulesResponseSuccess

export const getPolicyListPeriodicRulesUrl = () => {
  return `/api/policy/rules/periodic`
}

export const policyListPeriodicRules = async (
  options?: RequestInit
): Promise<policyListPeriodicRulesResponse> => {
  return customFetch<policyListPeriodicRulesResponse>(
    getPolicyListPeriodicRulesUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Create a new periodic rule
 * @summary Create Periodic Rule
 */
export type policyCreatePeriodicRuleResponse201 = {
  data: PolicyPeriodicRule
  status: 201
}

export type policyCreatePeriodicRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyCreatePeriodicRuleResponseSuccess =
  policyCreatePeriodicRuleResponse201 & {
    headers: Headers
  }
export type policyCreatePeriodicRuleResponseError =
  policyCreatePeriodicRuleResponse422 & {
    headers: Headers
  }

export type policyCreatePeriodicRuleResponse =
  | policyCreatePeriodicRuleResponseSuccess
  | policyCreatePeriodicRuleResponseError

export const getPolicyCreatePeriodicRuleUrl = () => {
  return `/api/policy/rules/periodic`
}

export const policyCreatePeriodicRule = async (
  periodicRuleCreate: PeriodicRuleCreate,
  options?: RequestInit
): Promise<policyCreatePeriodicRuleResponse> => {
  return customFetch<policyCreatePeriodicRuleResponse>(
    getPolicyCreatePeriodicRuleUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(periodicRuleCreate),
    }
  )
}

/**
 * Get a single periodic rule by ID
 * @summary Get Periodic Rule
 */
export type policyGetPeriodicRuleResponse200 = {
  data: PolicyPeriodicRule
  status: 200
}

export type policyGetPeriodicRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyGetPeriodicRuleResponseSuccess =
  policyGetPeriodicRuleResponse200 & {
    headers: Headers
  }
export type policyGetPeriodicRuleResponseError =
  policyGetPeriodicRuleResponse422 & {
    headers: Headers
  }

export type policyGetPeriodicRuleResponse =
  | policyGetPeriodicRuleResponseSuccess
  | policyGetPeriodicRuleResponseError

export const getPolicyGetPeriodicRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/periodic/${ruleId}`
}

export const policyGetPeriodicRule = async (
  ruleId: string,
  options?: RequestInit
): Promise<policyGetPeriodicRuleResponse> => {
  return customFetch<policyGetPeriodicRuleResponse>(
    getPolicyGetPeriodicRuleUrl(ruleId),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Update an existing periodic rule
 * @summary Update Periodic Rule
 */
export type policyUpdatePeriodicRuleResponse200 = {
  data: PolicyPeriodicRule
  status: 200
}

export type policyUpdatePeriodicRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyUpdatePeriodicRuleResponseSuccess =
  policyUpdatePeriodicRuleResponse200 & {
    headers: Headers
  }
export type policyUpdatePeriodicRuleResponseError =
  policyUpdatePeriodicRuleResponse422 & {
    headers: Headers
  }

export type policyUpdatePeriodicRuleResponse =
  | policyUpdatePeriodicRuleResponseSuccess
  | policyUpdatePeriodicRuleResponseError

export const getPolicyUpdatePeriodicRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/periodic/${ruleId}`
}

export const policyUpdatePeriodicRule = async (
  ruleId: string,
  periodicRuleUpdate: PeriodicRuleUpdate,
  options?: RequestInit
): Promise<policyUpdatePeriodicRuleResponse> => {
  return customFetch<policyUpdatePeriodicRuleResponse>(
    getPolicyUpdatePeriodicRuleUrl(ruleId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(periodicRuleUpdate),
    }
  )
}

/**
 * Delete a periodic rule
 * @summary Delete Periodic Rule
 */
export type policyDeletePeriodicRuleResponse200 = {
  data: PolicyDeletePeriodicRule200
  status: 200
}

export type policyDeletePeriodicRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyDeletePeriodicRuleResponseSuccess =
  policyDeletePeriodicRuleResponse200 & {
    headers: Headers
  }
export type policyDeletePeriodicRuleResponseError =
  policyDeletePeriodicRuleResponse422 & {
    headers: Headers
  }

export type policyDeletePeriodicRuleResponse =
  | policyDeletePeriodicRuleResponseSuccess
  | policyDeletePeriodicRuleResponseError

export const getPolicyDeletePeriodicRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/periodic/${ruleId}`
}

export const policyDeletePeriodicRule = async (
  ruleId: string,
  options?: RequestInit
): Promise<policyDeletePeriodicRuleResponse> => {
  return customFetch<policyDeletePeriodicRuleResponse>(
    getPolicyDeletePeriodicRuleUrl(ruleId),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

/**
 * Manually trigger a periodic rule to create a task
 * @summary Trigger Rule
 */
export type policyTriggerRuleResponse200 = {
  data: TriggerRuleResponse
  status: 200
}

export type policyTriggerRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type policyTriggerRuleResponseSuccess = policyTriggerRuleResponse200 & {
  headers: Headers
}
export type policyTriggerRuleResponseError = policyTriggerRuleResponse422 & {
  headers: Headers
}

export type policyTriggerRuleResponse =
  | policyTriggerRuleResponseSuccess
  | policyTriggerRuleResponseError

export const getPolicyTriggerRuleUrl = (ruleId: string) => {
  return `/api/policy/rules/periodic/${ruleId}/trigger`
}

export const policyTriggerRule = async (
  ruleId: string,
  options?: RequestInit
): Promise<policyTriggerRuleResponse> => {
  return customFetch<policyTriggerRuleResponse>(
    getPolicyTriggerRuleUrl(ruleId),
    {
      ...options,
      method: 'POST',
    }
  )
}

/**
 * Import rules from default JSON cache files (one-time import)
 * @summary Seed Rules From Defaults
 */
export type policySeedRulesFromDefaultsResponse200 = {
  data: RulesSeedResponse
  status: 200
}

export type policySeedRulesFromDefaultsResponseSuccess =
  policySeedRulesFromDefaultsResponse200 & {
    headers: Headers
  }
export type policySeedRulesFromDefaultsResponse =
  policySeedRulesFromDefaultsResponseSuccess

export const getPolicySeedRulesFromDefaultsUrl = () => {
  return `/api/policy/rules/seed`
}

export const policySeedRulesFromDefaults = async (
  options?: RequestInit
): Promise<policySeedRulesFromDefaultsResponse> => {
  return customFetch<policySeedRulesFromDefaultsResponse>(
    getPolicySeedRulesFromDefaultsUrl(),
    {
      ...options,
      method: 'POST',
    }
  )
}

/**
 * Extract rules from SharePoint PDFs and save to database
 * @summary Sync Rules From Sharepoint
 */
export type policySyncRulesFromSharepointResponse200 = {
  data: RulesSyncResponse
  status: 200
}

export type policySyncRulesFromSharepointResponseSuccess =
  policySyncRulesFromSharepointResponse200 & {
    headers: Headers
  }
export type policySyncRulesFromSharepointResponse =
  policySyncRulesFromSharepointResponseSuccess

export const getPolicySyncRulesFromSharepointUrl = () => {
  return `/api/policy/rules/sync`
}

export const policySyncRulesFromSharepoint = async (
  options?: RequestInit
): Promise<policySyncRulesFromSharepointResponse> => {
  return customFetch<policySyncRulesFromSharepointResponse>(
    getPolicySyncRulesFromSharepointUrl(),
    {
      ...options,
      method: 'POST',
    }
  )
}

/**
 * Get all periodic tasks with optional filters, pagination and sorting
 * @summary Get Periodic Tasks
 */
export type tasksGetPeriodicTasksResponse200 = {
  data: PeriodicTasksListResponse
  status: 200
}

export type tasksGetPeriodicTasksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksGetPeriodicTasksResponseSuccess =
  tasksGetPeriodicTasksResponse200 & {
    headers: Headers
  }
export type tasksGetPeriodicTasksResponseError =
  tasksGetPeriodicTasksResponse422 & {
    headers: Headers
  }

export type tasksGetPeriodicTasksResponse =
  | tasksGetPeriodicTasksResponseSuccess
  | tasksGetPeriodicTasksResponseError

export const getTasksGetPeriodicTasksUrl = (
  params?: TasksGetPeriodicTasksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/tasks/periodic?${stringifiedParams}`
    : `/api/tasks/periodic`
}

export const tasksGetPeriodicTasks = async (
  params?: TasksGetPeriodicTasksParams,
  options?: RequestInit
): Promise<tasksGetPeriodicTasksResponse> => {
  return customFetch<tasksGetPeriodicTasksResponse>(
    getTasksGetPeriodicTasksUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Get task by id
 * @summary Get Periodic Task By Id
 */
export type tasksGetPeriodicTaskByIdResponse200 = {
  data: PeriodicTask
  status: 200
}

export type tasksGetPeriodicTaskByIdResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksGetPeriodicTaskByIdResponseSuccess =
  tasksGetPeriodicTaskByIdResponse200 & {
    headers: Headers
  }
export type tasksGetPeriodicTaskByIdResponseError =
  tasksGetPeriodicTaskByIdResponse422 & {
    headers: Headers
  }

export type tasksGetPeriodicTaskByIdResponse =
  | tasksGetPeriodicTaskByIdResponseSuccess
  | tasksGetPeriodicTaskByIdResponseError

export const getTasksGetPeriodicTaskByIdUrl = (taskId: string) => {
  return `/api/tasks/periodic/${taskId}`
}

export const tasksGetPeriodicTaskById = async (
  taskId: string,
  options?: RequestInit
): Promise<tasksGetPeriodicTaskByIdResponse> => {
  return customFetch<tasksGetPeriodicTaskByIdResponse>(
    getTasksGetPeriodicTaskByIdUrl(taskId),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Start multiple periodic tasks at once
 * @summary Start Periodic Task
 */
export type tasksStartPeriodicTaskResponse200 = {
  data: BatchTaskOperationResponse
  status: 200
}

export type tasksStartPeriodicTaskResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksStartPeriodicTaskResponseSuccess =
  tasksStartPeriodicTaskResponse200 & {
    headers: Headers
  }
export type tasksStartPeriodicTaskResponseError =
  tasksStartPeriodicTaskResponse422 & {
    headers: Headers
  }

export type tasksStartPeriodicTaskResponse =
  | tasksStartPeriodicTaskResponseSuccess
  | tasksStartPeriodicTaskResponseError

export const getTasksStartPeriodicTaskUrl = () => {
  return `/api/tasks/periodic/start`
}

export const tasksStartPeriodicTask = async (
  periodicTaskBatchStartRequest: PeriodicTaskBatchStartRequest,
  options?: RequestInit
): Promise<tasksStartPeriodicTaskResponse> => {
  return customFetch<tasksStartPeriodicTaskResponse>(
    getTasksStartPeriodicTaskUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(periodicTaskBatchStartRequest),
    }
  )
}

/**
 * Mark multiple periodic tasks as completed
 * @summary Complete Periodic Task
 */
export type tasksCompletePeriodicTaskResponse200 = {
  data: PeriodicTaskBatchOperationResponse
  status: 200
}

export type tasksCompletePeriodicTaskResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksCompletePeriodicTaskResponseSuccess =
  tasksCompletePeriodicTaskResponse200 & {
    headers: Headers
  }
export type tasksCompletePeriodicTaskResponseError =
  tasksCompletePeriodicTaskResponse422 & {
    headers: Headers
  }

export type tasksCompletePeriodicTaskResponse =
  | tasksCompletePeriodicTaskResponseSuccess
  | tasksCompletePeriodicTaskResponseError

export const getTasksCompletePeriodicTaskUrl = () => {
  return `/api/tasks/periodic/complete`
}

export const tasksCompletePeriodicTask = async (
  periodicTaskBatchStartRequest: PeriodicTaskBatchStartRequest,
  options?: RequestInit
): Promise<tasksCompletePeriodicTaskResponse> => {
  return customFetch<tasksCompletePeriodicTaskResponse>(
    getTasksCompletePeriodicTaskUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(periodicTaskBatchStartRequest),
    }
  )
}

/**
 * Get all tasks with optional filters, pagination and sorting
 * @summary Get All Tasks
 */
export type tasksGetAllTasksResponse200 = {
  data: TasksListResponse
  status: 200
}

export type tasksGetAllTasksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksGetAllTasksResponseSuccess = tasksGetAllTasksResponse200 & {
  headers: Headers
}
export type tasksGetAllTasksResponseError = tasksGetAllTasksResponse422 & {
  headers: Headers
}

export type tasksGetAllTasksResponse =
  | tasksGetAllTasksResponseSuccess
  | tasksGetAllTasksResponseError

export const getTasksGetAllTasksUrl = (params?: TasksGetAllTasksParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/tasks/remediation?${stringifiedParams}`
    : `/api/tasks/remediation`
}

export const tasksGetAllTasks = async (
  params?: TasksGetAllTasksParams,
  options?: RequestInit
): Promise<tasksGetAllTasksResponse> => {
  return customFetch<tasksGetAllTasksResponse>(getTasksGetAllTasksUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * Get task by id
 * @summary Get Task By Id
 */
export type tasksGetTaskByIdResponse200 = {
  data: RemediationTask
  status: 200
}

export type tasksGetTaskByIdResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksGetTaskByIdResponseSuccess = tasksGetTaskByIdResponse200 & {
  headers: Headers
}
export type tasksGetTaskByIdResponseError = tasksGetTaskByIdResponse422 & {
  headers: Headers
}

export type tasksGetTaskByIdResponse =
  | tasksGetTaskByIdResponseSuccess
  | tasksGetTaskByIdResponseError

export const getTasksGetTaskByIdUrl = (taskId: string) => {
  return `/api/tasks/remediation/${taskId}`
}

export const tasksGetTaskById = async (
  taskId: string,
  options?: RequestInit
): Promise<tasksGetTaskByIdResponse> => {
  return customFetch<tasksGetTaskByIdResponse>(getTasksGetTaskByIdUrl(taskId), {
    ...options,
    method: 'GET',
  })
}

/**
 * Approve multiple tasks at once
 * @summary Approve Tasks
 */
export type tasksApproveTasksResponse200 = {
  data: RemediationTaskBatchOperationResponse
  status: 200
}

export type tasksApproveTasksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksApproveTasksResponseSuccess = tasksApproveTasksResponse200 & {
  headers: Headers
}
export type tasksApproveTasksResponseError = tasksApproveTasksResponse422 & {
  headers: Headers
}

export type tasksApproveTasksResponse =
  | tasksApproveTasksResponseSuccess
  | tasksApproveTasksResponseError

export const getTasksApproveTasksUrl = () => {
  return `/api/tasks/remediation/approve`
}

export const tasksApproveTasks = async (
  batchApprovalRequest: BatchApprovalRequest,
  options?: RequestInit
): Promise<tasksApproveTasksResponse> => {
  return customFetch<tasksApproveTasksResponse>(getTasksApproveTasksUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchApprovalRequest),
  })
}

/**
 * Reject multiple tasks at once
 * @summary Reject Tasks
 */
export type tasksRejectTasksResponse200 = {
  data: RemediationTaskBatchOperationResponse
  status: 200
}

export type tasksRejectTasksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type tasksRejectTasksResponseSuccess = tasksRejectTasksResponse200 & {
  headers: Headers
}
export type tasksRejectTasksResponseError = tasksRejectTasksResponse422 & {
  headers: Headers
}

export type tasksRejectTasksResponse =
  | tasksRejectTasksResponseSuccess
  | tasksRejectTasksResponseError

export const getTasksRejectTasksUrl = () => {
  return `/api/tasks/remediation/reject`
}

export const tasksRejectTasks = async (
  batchRejectionRequest: BatchRejectionRequest,
  options?: RequestInit
): Promise<tasksRejectTasksResponse> => {
  return customFetch<tasksRejectTasksResponse>(getTasksRejectTasksUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchRejectionRequest),
  })
}

/**
 * Get notifications for the current user, optionally filtered by read status or task ID
 * @summary Get Notifications
 */
export type notificationsGetNotificationsResponse200 = {
  data: NotificationsListResponse
  status: 200
}

export type notificationsGetNotificationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type notificationsGetNotificationsResponseSuccess =
  notificationsGetNotificationsResponse200 & {
    headers: Headers
  }
export type notificationsGetNotificationsResponseError =
  notificationsGetNotificationsResponse422 & {
    headers: Headers
  }

export type notificationsGetNotificationsResponse =
  | notificationsGetNotificationsResponseSuccess
  | notificationsGetNotificationsResponseError

export const getNotificationsGetNotificationsUrl = (
  params?: NotificationsGetNotificationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/notifications?${stringifiedParams}`
    : `/api/notifications`
}

export const notificationsGetNotifications = async (
  params?: NotificationsGetNotificationsParams,
  options?: RequestInit
): Promise<notificationsGetNotificationsResponse> => {
  return customFetch<notificationsGetNotificationsResponse>(
    getNotificationsGetNotificationsUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Mark multiple notifications as read
 * @summary Mark Notifications Read
 */
export type notificationsMarkNotificationsReadResponse200 = {
  data: BatchMarkReadResponse
  status: 200
}

export type notificationsMarkNotificationsReadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type notificationsMarkNotificationsReadResponseSuccess =
  notificationsMarkNotificationsReadResponse200 & {
    headers: Headers
  }
export type notificationsMarkNotificationsReadResponseError =
  notificationsMarkNotificationsReadResponse422 & {
    headers: Headers
  }

export type notificationsMarkNotificationsReadResponse =
  | notificationsMarkNotificationsReadResponseSuccess
  | notificationsMarkNotificationsReadResponseError

export const getNotificationsMarkNotificationsReadUrl = () => {
  return `/api/notifications/read`
}

export const notificationsMarkNotificationsRead = async (
  batchMarkReadRequest: BatchMarkReadRequest,
  options?: RequestInit
): Promise<notificationsMarkNotificationsReadResponse> => {
  return customFetch<notificationsMarkNotificationsReadResponse>(
    getNotificationsMarkNotificationsReadUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(batchMarkReadRequest),
    }
  )
}

/**
 * Get audit log entries with filtering, sorting, and pagination
 * @summary Get Audit Logs
 */
export type auditGetAuditLogsResponse200 = {
  data: AuditLogResponse
  status: 200
}

export type auditGetAuditLogsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type auditGetAuditLogsResponseSuccess = auditGetAuditLogsResponse200 & {
  headers: Headers
}
export type auditGetAuditLogsResponseError = auditGetAuditLogsResponse422 & {
  headers: Headers
}

export type auditGetAuditLogsResponse =
  | auditGetAuditLogsResponseSuccess
  | auditGetAuditLogsResponseError

export const getAuditGetAuditLogsUrl = (params?: AuditGetAuditLogsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/audit?${stringifiedParams}`
    : `/api/audit`
}

export const auditGetAuditLogs = async (
  params?: AuditGetAuditLogsParams,
  options?: RequestInit
): Promise<auditGetAuditLogsResponse> => {
  return customFetch<auditGetAuditLogsResponse>(
    getAuditGetAuditLogsUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Get compliancy statistics
 * @summary Get Compliancy Statistics
 */
export type statisticsGetCompliancyStatisticsResponse200 = {
  data: StatisticsCompliancyResponse
  status: 200
}

export type statisticsGetCompliancyStatisticsResponseSuccess =
  statisticsGetCompliancyStatisticsResponse200 & {
    headers: Headers
  }
export type statisticsGetCompliancyStatisticsResponse =
  statisticsGetCompliancyStatisticsResponseSuccess

export const getStatisticsGetCompliancyStatisticsUrl = () => {
  return `/api/statistics/compliancy`
}

export const statisticsGetCompliancyStatistics = async (
  options?: RequestInit
): Promise<statisticsGetCompliancyStatisticsResponse> => {
  return customFetch<statisticsGetCompliancyStatisticsResponse>(
    getStatisticsGetCompliancyStatisticsUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Get task totals statistics
 * @summary Get Task Totals
 */
export type statisticsGetTaskTotalsResponse200 = {
  data: StatisticsTaskTotals
  status: 200
}

export type statisticsGetTaskTotalsResponseSuccess =
  statisticsGetTaskTotalsResponse200 & {
    headers: Headers
  }
export type statisticsGetTaskTotalsResponse =
  statisticsGetTaskTotalsResponseSuccess

export const getStatisticsGetTaskTotalsUrl = () => {
  return `/api/statistics/tasks`
}

export const statisticsGetTaskTotals = async (
  options?: RequestInit
): Promise<statisticsGetTaskTotalsResponse> => {
  return customFetch<statisticsGetTaskTotalsResponse>(
    getStatisticsGetTaskTotalsUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Get compliancy statistics
 * @summary Get Remediation Tasks Statistics
 */
export type statisticsGetRemediationTasksStatisticsResponse200 = {
  data: RemediationTaskDataPoint[]
  status: 200
}

export type statisticsGetRemediationTasksStatisticsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type statisticsGetRemediationTasksStatisticsResponseSuccess =
  statisticsGetRemediationTasksStatisticsResponse200 & {
    headers: Headers
  }
export type statisticsGetRemediationTasksStatisticsResponseError =
  statisticsGetRemediationTasksStatisticsResponse422 & {
    headers: Headers
  }

export type statisticsGetRemediationTasksStatisticsResponse =
  | statisticsGetRemediationTasksStatisticsResponseSuccess
  | statisticsGetRemediationTasksStatisticsResponseError

export const getStatisticsGetRemediationTasksStatisticsUrl = (
  params: StatisticsGetRemediationTasksStatisticsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/statistics/tasks/remediation?${stringifiedParams}`
    : `/api/statistics/tasks/remediation`
}

export const statisticsGetRemediationTasksStatistics = async (
  params: StatisticsGetRemediationTasksStatisticsParams,
  options?: RequestInit
): Promise<statisticsGetRemediationTasksStatisticsResponse> => {
  return customFetch<statisticsGetRemediationTasksStatisticsResponse>(
    getStatisticsGetRemediationTasksStatisticsUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

/**
 * Root endpoint
 * @summary Root
 */
export type apiRootResponse200 = {
  data: RootResponse
  status: 200
}

export type apiRootResponseSuccess = apiRootResponse200 & {
  headers: Headers
}
export type apiRootResponse = apiRootResponseSuccess

export const getApiRootUrl = () => {
  return `/`
}

export const apiRoot = async (
  options?: RequestInit
): Promise<apiRootResponse> => {
  return customFetch<apiRootResponse>(getApiRootUrl(), {
    ...options,
    method: 'GET',
  })
}
